import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=22946e92&scoped=true&lang=pug"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&id=22946e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22946e92",
  null
  
)

export default component.exports